<template>
    <div class="register">
        <brave-form action="https://www.bravenet.com/signup/signup.php" v-bind="form" :validate="validate" :sending="sending">
            <md-card class="md-flex-50 md-flex-small-100">

                <md-card-header>
                    <div class="md-title">Create your FREE Bravenet Account</div>
                    

                    
                    <div class="header-helper">
                        Already have a Bravenet account?
                        <a v-if="asModal == true" class="underline accent" @click="swapToLogin">Log in</a>
                        <router-link v-else :to="{path: '/login', query}" class="underline accent">Log in</router-link>
                    </div>
                  <section v-for="(content, name) in errors" :key="name">
                    <div class="error-container" v-if="content">
                      <div v-if="name === 'serverMessage'" v-html="content"></div>
                      <div v-else v-html="$t(`register.ERROR_${name.toUpperCase()}`)"></div>
                    </div>
                  </section>

                </md-card-header>
                <md-card-content>
                    <div class="md-layout-row md-layout-wrap md-gutter">
                        <div class="md-flex md-flex-small-100">
                            <noscript>
                                <label for="full_name">Your Full Name</label>
                            </noscript>
                            <md-field :class="getValidationClass('full_name')">
                                <label v-if="nojs == false" for="full_name">Your Full Name</label>
                                <md-input :style="{fontSize: (nojs) ? '14px' : ''}" name="full_name" id="full_name" autocomplete="given-name" v-model="form.full_name" :disabled="sending" />
                                <span class="md-error" v-if="!$v.form.full_name.required">Your full name is required</span>
                                <span class="md-error" v-else-if="!$v.form.full_name.minlength">Invalid name</span>
                            </md-field>
                        </div>
                    </div>
                    <div class="md-layout-row md-layout-wrap md-gutter">
                        <div class="md-flex md-flex-small-100">
                            <noscript>
                                <label for="email">Email Address</label>
                            </noscript>
                            <md-field :class="getValidationClass('email')">
                                <label v-if="nojs == false" for="email">Email Address</label>
                                <md-input :style="{fontSize: (nojs) ? '14px' : ''}" name="email" id="email" autocomplete="given-name" v-model="form.email" :disabled="sending" />
                                <span class="md-error" v-if="!$v.form.email.required">Email address is required</span>
                                <span class="md-error" v-else-if="!$v.form.email.minlength">Invalid email address</span>
                            </md-field>
                        </div>

                    </div>
                    <div class="md-layout-row md-layout-wrap md-gutter">

                        <div class="md-flex md-flex-small-100">
                            <noscript>
                                <label for="username">Username</label>
                            </noscript>
                            <md-field :class="getValidationClass('username')">
                                <label v-if="nojs == false" for="username">Username</label>
                                <md-input :style="{fontSize: (nojs) ? '14px' : ''}" name="username" id="username" autocomplete="given-name" v-model="form.username" :disabled="sending" />
                                <span class="md-error" v-if="!$v.form.username.required">Username is required</span>
                                <span class="md-error" v-else-if="!$v.form.username.isemail">Invalid username</span>
                                <span class="md-error" v-else-if="!$v.form.username.minlength">Invalid username</span>
                                <span class="md-error" v-else-if="!$v.form.username.isUnique">This username has been taken, please try another</span>
                            </md-field>
                        </div>

                    </div>
                    <div class="md-layout-row md-layout-wrap md-gutter">

                        <div class="md-flex md-flex-small-100">
                            <noscript>
                                <label for="password">Password</label>
                            </noscript>
                            <password-field
                                id="password"
                                name="password"
                                v-model="form.password"
                                :disabled="sending"
                                :field-class="getValidationClass('password')"
                                :nojs="nojs"
                                :input-style="{fontSize: (nojs) ? '14px' : ''}"
                            >
                                <label v-if="nojs == false" for="password" slot="label">Password</label>
                                <span class="md-error" v-if="!$v.form.password.required">Password is required</span>
                                <span class="md-error" v-else-if="!$v.form.password.minlength">Invalid password</span>
                            </password-field>
                        </div>

                    </div>
                    <div class="md-layout-row md-layout-wrap md-gutter">

                        <div class="md-flex md-flex-small-100">
                            <noscript>
                                <label for="password_validation">Password Confirm</label>
                            </noscript>
                            <password-field
                                id="password_validation"
                                name="password_validation"
                                v-model="form.password_validation"
                                :disabled="sending"
                                :field-class="getValidationClass('password_validation')"
                                :nojs="nojs"
                                :input-style="{fontSize: (nojs) ? '14px' : ''}"
                            >
                                <label v-if="nojs == false" for="password_validation" slot="label">Password Confirm</label>
                                <span class="md-error" v-if="!$v.form.password_validation.required">Password is required</span>
                                <span class="md-error" v-else-if="!$v.form.password_validation.minlength">Invalid password</span>
                            </password-field>
                        </div>
                        <input type="hidden" name="tosagree" value="1"/>
                        <input type="hidden" name="signup_form_submitted" value="1"/>
                        <input type="hidden" name="signup_step" value="false"/>
                        <input type="hidden" name="form_key" value="ignore"/>
                        <input type="hidden" name="form_name" value="signup_form"/>
                    </div>

                    <div v-if="captchaRequired" class="md-layout-row md-layout-wrap md-gutter">
                        <div class="md-flex md-flex-small-100">
                            <altcha ref="recaptcha" />
                        </div>
                    </div>

                </md-card-content>

                <md-card-actions>
                    <md-button type="submit" class="md-primary md-raised md-accent" :disabled="sending">Create Account</md-button>
                </md-card-actions>

            </md-card>
            <div class="helper-links">
                <span>By logging in, you agree to Bravenet's <router-link to="/terms" class="accent underline">terms of service</router-link>, <a class="accent underline" @click="openPrivacyPolicyModal">privacy policy</a>, and to receive important Member's updates&nbsp;by&nbsp;email.</span>

            </div>
        </brave-form>
    </div>
</template>

<script>
import Vue from 'vue'
import FormExtension from 'brave-form/components/extension'
import BravenetAPI from 'brave-api/bravenet'
import style from 'brave-authentication/components/login-register.scss'
import recaptcha from 'brave-authentication/components/recaptcha'
import altcha from 'brave-authentication/components/altcha'
import passwordField from 'brave-authentication/components/password-field'
import login from 'brave-authentication/components/login'
import privacyPolicy from 'brave-company/components/privacy-policy'
import QueryString from 'brave-utils/query-string'
import { validationMixin } from 'vuelidate'
import {
    required,
    email,
    minLength,
    maxLength
} from 'vuelidate/lib/validators'

let isEmail = (value) => (value!==null) ? value.indexOf('@') === -1 : false

export default {
    extends: FormExtension,
    name: 'RegisterForm',
    mixins: [validationMixin],
    components: {
        altcha,
        passwordField
    },
    data: () => {
        let randomNumber = 0
        if (process.env.NODE_ENV === 'development') {
            randomNumber = Math.floor(Math.random() * 10000)
        }
        let qs = new QueryString(window.location.search)
        let params = qs.toSingleValueDict()
        let from = (params.from)
            ? params.from
            : null

        let cart_hash = (params.cart_hash)

        let query = (from)
            ? { from: from }
            : (cart_hash) ? { cart_hash: cart_hash } : {}

        if(params.template_id!==undefined) {
            query.template_id = params.template_id
        }
        
        if(params.type!==undefined) {
            query.type = params.type
        }

        return {
            form: (process.env.NODE_ENV === 'development')
                ? {
                    full_name: `Bot ${randomNumber}`,
                    email: `steve+${randomNumber}@bravenet.com`,
                    username: `steve-${randomNumber}`,
                    password: `testing123`,
                    password_validation: `testing123`,
                }
                : {
                    full_name: null,
                    email: null,
                    username: null,
                    password: null,
                    password_validation: null,
                },
            errors: {
                unexpected: false,
                serverMessage: false
            },
            captchaRequired: true,
            query,
            checkingUsername: false,
            unavailableUsername: false,
            nojs: (/PRERENDER/.test(window.navigator.userAgent))
        }
    },

    validations: {
        form: {
            full_name: {
                required,
                minLength: minLength(2)
            },
            email: {
                required,
                minLength: minLength(3)
            },
            username: {
                required,
                minLength: minLength(3),
                isemail: isEmail,
                // async isUnique (value) {
                //   if (value === '') return true
                //   let response = await BravenetAPI.checkUsername({userid: value})
                //   if (response.status === "ERROR") {
                //     console.log(' return false', this.$v)
                //     return false
                //   }

                //   return true
                // }
            },
            password: {
                required,
                minLength: minLength(3)
            },
            password_validation: {
                required,
                minLength: minLength(3)
            },
        }
    },
    methods: {
        clearForm () {
            this.form.userid = null
            this.form.password = null
            this.form.rememberme = false
        },
        async checkUsername (value, resolve) {


            let data = await BravenetAPI.checkUsername({userid: value})
            if (data.status === "ERROR") {
                return false
            }
            return true
        },
        async onSubmit () {
            let additionalPayload = (this.captchaRequired)
                ? {
                    'altcha': this.$refs.recaptcha ? this.$refs.recaptcha.value : null
                }
                : {}
            
            // Debug logging
            if (this.captchaRequired) {
                console.log('ALTCHA: Submitting registration with token:', additionalPayload.altcha ? 'Token present' : 'Token missing');
                if (!additionalPayload.altcha) {
                    this.errors.serverMessage = 'Please complete the security verification before submitting.';
                    return;
                }
            }
            
            let payload = Object.assign(this.form, additionalPayload)
            let data = await BravenetAPI.register(payload)
            if (data.status === "ERROR") {
                if (this.captchaRequired == true) {
                    this.$refs.recaptcha.resetRecaptcha()
                }
                let errorMessage = 'Something went wrong. Please refresh the page and try again later.';
                if (data.response && data.response.reason) {
                    errorMessage = data.response.reason;
                    if (errorMessage == 'You must verify the captcha.') {
                        this.captchaRequired = true
                    }
                }

                this.errors.serverMessage = errorMessage
            } else if (data.status === "SUCCESS") {
                if (this.asModal) {
                    this.onSuccess(data)
                } else {
                    let redirectUrl = data.response.redirect
                    if (redirectUrl.indexOf('?') !== -1) {
                        redirectUrl = `${redirectUrl}&braveui=1${this.query.template_id ? `&template_id=${this.query.template_id}` : ''}${this.query.type ? `&type=${this.query.type}` : ''}`
                    } else {
                        redirectUrl = `${redirectUrl}?braveui=1${this.query.template_id ? `&template_id=${this.query.template_id}` : ''}${this.query.type ? `&type=${this.query.type}` : ''}`
                    }
                    window.location.assign(redirectUrl)
                }
            }


            this.afterSubmit()
        },
        swapToLogin () {
            // Use props type if available, otherwise fall back to query type
            const typeToPass = this.type || this.query.type
            
            this.$store.dispatch('popModal')
            this.$store.dispatch('pushModal', {component: login, props: {onSuccess: this.onSuccess, from: this.from, template_id: this.template_id, type: typeToPass}})
        },
        openPrivacyPolicyModal () {
            this.$store.dispatch('pushModal', {component: privacyPolicy})
        }
    },
    props: ['asModal', 'onSuccess', 'from', 'template_id', 'type']
}
</script>
